import styled from 'styled-components';
import { H1, InfoTooltip } from 'src/components/atoms';

export const StyledTitle = styled(H1)`
  display: flex;
  align-items: center;
`;

export const StyledInfoTooltip = styled(InfoTooltip)`
  display: flex;
  align-items: center;
  padding: 0 8px;
  transform: none;
`;
